import React from 'react';
import { Icon } from 'semantic-ui-react';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _times from 'lodash/times';
import { ACTIVE_ICON_CLASS_NAME, INACTIVE_ICON_CLASS_NAME, RATING_ICON } from './Rating.constants';
import { MAX_RATING_VALUE } from '../../Review.constants';
import './Rating.css';
var defaultProps = {
  maxRating: MAX_RATING_VALUE
};
export default function Rating(_ref) {
  var rating = _ref.rating,
    maxRating = _ref.maxRating;
  if (_isNil(rating)) {
    return null;
  }
  var ratingNumber = +rating;
  if (!_isNumber(ratingNumber)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "rating-container"
  }, _times(maxRating).map(function (index) {
    var isActive = index + 1 <= ratingNumber;
    var iconClassName = isActive ? ACTIVE_ICON_CLASS_NAME : INACTIVE_ICON_CLASS_NAME;
    return /*#__PURE__*/React.createElement(Icon, {
      key: index,
      className: iconClassName,
      name: RATING_ICON,
      active: isActive
    });
  }));
}
Rating.defaultProps = defaultProps;